export default "__VITE_ASSET__DSSK$t2K__"